//Provider Service 중 Question에 나타나는 Sub들 전역 Vuex
import Vue from 'vue';
import axios from '@core_utils/api/_axios.js'
import { generateSubcomponentDataBy } from '@core_utils/subComponent/subComponent';
import commonLogout from '@core_utils/common-logout';

// readSubs 요청 순번 — 문항을 빠르게 옮기면 늦게 도착한 앞 문항 응답이 뒤 문항 본문을 덮지 않게 마지막 요청만 반영한다
let latest_read_subs = 0

const questions = {
    namespaced: true,
    state: {
        subs: [],
        subs_loaded: false,
        subs_error: false,
        answer_company: {},
        edit_mode: true,
    },
    getters: {
        getter_question_edit_mode (state) {
            return state.edit_mode
        },
        getter_question_answer_company (state) {
            return state.answer_company
        }
    },
    mutations: {
        update_subs(state, new_subs){
            state.subs = new_subs
        },
        add_sub(state, new_sub){
            state.subs.push(new_sub)
        },
        update_sub (state, new_sub) {
            let idx = state.subs.findIndex(item => (new_sub.sub_id && item.sub_id && new_sub.sub_id === item.sub_id) || (!item.sub_id && item.sub_init_id == new_sub.sub_init_id))
            if (idx > -1) {
                Vue.set(state.subs, idx, Object.assign({}, state.subs[idx], new_sub))
            }
        },
        update_subs_loaded(state, new_status){
            state.subs_loaded = new_status
        },
        update_subs_error(state, is_error){
            state.subs_error = is_error
        },
        update_answer_company(state, new_company){
            state.answer_company = new_company
        },
        change_edit_mode(state, mode){
            state.edit_mode = mode
        },
        reset_subs(state){
            latest_read_subs += 1 // 진행 중인 readSubs 응답은 버린다
            state.subs = []
            state.subs_loaded = false
            state.subs_error = false
        }
    },
    actions: {
        // 반환값: 이 요청이 마지막 요청이라 결과를 반영했으면 true, 더 새 요청이 있어 버렸으면 false
        // (false 면 호출부는 옛 문항으로 이동·오류 안내를 하지 않는다. 401 은 undefined)
        async readSubs ({ commit }, question) {
            const request_no = ++latest_read_subs
            const is_latest = () => request_no === latest_read_subs
            try {
                let temp_result = []
                commit('update_subs', [])
                commit('update_subs_loaded', false)
                commit('update_subs_error', false)

                if (question.contents && question.contents.length) {
                    const _question_contents = Array.isArray(question.contents)
                        ? question.contents.join(',')
                        : !question.contents
                            ? ''
                            : typeof question.contents === "string"
                                ? JSON.parse(question.contents).join(',')
                                : question.content.join(',')

                    const _res_subs_init = await axios.get('/subs', {
                        params: {
                            company_id: question.company_id,
                            company_name: question.company_name,
                            campaign_id: question.campaign_id,
                            sub_codes: _question_contents
                        }
                    })

                    if (_res_subs_init.data.length) {
                        temp_result = _question_contents.split(',').reduce((_reordered_subs, _sub_code) => {
                            let subs = _res_subs_init.data.find(({ sub_code }) => sub_code === _sub_code)
                            if (subs) _reordered_subs.push(generateSubcomponentDataBy(subs, question.question_code))
                            return _reordered_subs
                        }, [])
                    }
                }

                if (!is_latest()) return false
                commit('update_subs', temp_result)
                commit('update_subs_loaded', true)
                return true
            } catch (error) {
                console.log(error);
                if (!is_latest()) return false
                // 401 은 로그아웃 처리로 끝내고, 나머지 오류는 호출부가 알 수 있게 다시 던진다
                if (error.response && error.response.status === 401) {
                    await commonLogout()
                    return
                }
                commit('update_subs_error', true)
                throw error;
            }
        },
        // 1.Auditor 용 subs_adjust 읽어오기
            // subs_adjust는 기존 sub의 복제본으로 가져옴 (read_sub 대신하는 역할)
            // subs 통 복사가 아니라, foriegn_key(campaign_id, sub_code, company_name) + sub_data_contents, + author_name, author_comment, time_stamp 저장
        
        // 2. SubComponentMixin.js에서 initiateData 말고 audit_mode 일 때 initiate할 함수 하나 더 불러서 그려주기

        // 3. 각 subcomponent에서 값을 수정/편집한 다음 저장 
            // 기존 save_sub과 다르게 DB의 subs_adjust 테이블로 저장해야 함
            // v-model을 분리해서, audit_mode일때 save_sub_adjust 로 저장하도록 조정
            // 기존과 다르게 저장하려면 sub_data_conents를 다르게 받아야 함        
    }
}

export default questions
